export default () => ({
    formData: {
        email: '',
        privacy_policy: false,
    },
    message: '',
    heading: '',
    showModal: false,
    processing: false,
    subscribed: false,
    resetForm() {
        this.formData.email = ''
        this.formData.privacy_policy = false
        this.processing = false
    },
    async submitData() {

        const lang = document.getElementsByTagName('html')[0].getAttribute('lang')

        this.processing = true

        let messages = {

            'heading': {
                'en-GB': 'Thank you',
                'sk-SK': 'Ďakujeme',
                'cs-CZ': 'Děkujeme',
            },
            'succes_message': {
                'en-GB': 'Thank you, We have added your e-mail to our newsletter subscription.',
                'sk-SK': 'Ďakujeme, Váš e-mail sme zaradili na odber nášho newsletra.',
                'cs-CZ': 'Děkujeme, Váš e-mail jsme zařadili k odběru našeho newsleteru.',
            },
            'allread_in_message': {
                'en-GB': 'Your e-mail has already been subscribed to our newsletter.',
                'sk-SK': 'Váš e-mail už existuje v našej databáze na odber newsletera.',
                'cs-CZ': 'Váš e-mail je již zařazen k odběru našeho newsleteru.',
            },
            'error_heading': {
                'en-GB': 'Error',
                'sk-SK': 'Chyba',
                'cs-CZ': 'Chyba',
            },
            'error_message': {
                'en-GB': 'An unknown error has occurred. Try subscribing to our newsletter again. <br>Thank you',
                'sk-SK': 'Vyskytla sa neznáma chyba. Skúste sa k odberu nášho newslettra prihlásiť ešte raz. <br>Ďakujeme.',
                'cs-CZ': 'Vyskytla se neznámá chyba. Zkuste se k odběru našeho newsletteru přihlásit ještě jednou. <br>Děkujeme'
            }
        }


        axios.post('/newsletter', {
            data: this.formData
        })
            .then((response) => {
                this.subscribed = true
                this.heading = messages.heading[lang]
                this.message = messages.succes_message[lang]
                this.showModal = true
            })
            .catch((error) => {
                this.heading = messages.error_heading[lang]
                this.message = messages.error_message[lang]
                if (error.response.data.title == 'Member Exists') {
                    this.message = messages.allread_in_message[lang]
                    this.heading = messages.heading[lang]
                }
                this.showModal = true
            })
            .finally(() => {
                this.resetForm()
            })
    }
})
